// 全局默认配置项
// 首页地址[默认]
export const HOME_URL: string = '/chat';

// 默认主题颜色
export const DEFAULT_THEME_COLOR: string = '#2992FF';

// 折叠阈值
export const COLLAPSE_THRESHOLD: number = 600;

// 左侧菜单宽度
export const SIDE_BAR_WIDTH: number = 280;

// 路由白名单地址[无需登录即可访问]
export const ROUTER_WHITE_LIST: string[] = [
  '/login',
  '/apply',
  '/user-agreement',
  '/privacy-policy',
  '/apikey-usage',
  '/403',
  '/404',
  '/apikey-usage',
  // 以下页面风控期间未登录禁止访问
  // '/chat/conversation',
  // '/chat/conversation/:id',
  // '/chat/image',
  // '/chat/video',
  // '/chat/agent',
  // '/chat/yxcode',
  // '/chat/claw',
  // '/model-library',
  // '/ranking',
  // '/coding-plan',
  // '/docs',
  // '/docs/:slug',
  // '/products',
  // '/activity/:id',
  // '/announcement/:id',
  // '/pay-result',
];

// 备份：原白名单（所有页面免登录访问时恢复此列表）
// export const ROUTER_WHITE_LIST: string[] = [
//   '/login',
//   '/chat',
//   '/chat/conversation',
//   '/chat/image',
//   '/chat/video',
//   '/chat/agent',
//   '/chat/api',
//   '/chat/yxcode',
//   '/chat/claw',
//   '/model-library',
//   '/products',
//   '/pay-result',
//   '/activity/:id',
//   '/announcement/:id',
//   '/403',
//   '/404',
//   '/apikey-usage',
//   '/ranking',
//   'coding-plan',
//   '/docs',
//   '/docs/:slug',
// ];
